// extracted by mini-css-extract-plugin
export var actionButton = "_nr-0";
export var actionMenuContainer = "_nr-i";
export var bubble = "_nr-2";
export var bubbleActionMenu = "_nr-j";
export var bubbleContext = "_nr-6";
export var bubbleItems = "_nr-7";
export var customer = "_nr-3";
export var divider = "_nr-8";
export var fileList = "_nr-9";
export var hiddenComment = "_nr-o";
export var infoAbove = "_nr-a";
export var internal = "_nr-4";
export var lightActionButton = "_nr-1";
export var link = "_nr-b";
export var merchant = "_nr-5";
export var message = "_nr-c";
export var profilePicture = "_nr-e";
export var quillToolbarContainer = "_nr-f";
export var senderDate = "_nr-g";
export var senderDateCustomer = "_nr-h";
export var senderName = "_nr-d";
export var time = "_nr-k";
export var uploadedImage = "_nr-l";
export var username = "_nr-m";
export var xsmall = "_nr-n";